import React from "react";
import { BasketProvider } from "./src/context/basket-context";

import "./src/styles/main.scss";

export const wrapPageElement = ({ element }) => (
  <BasketProvider>{element}</BasketProvider>
);
